import React, { cloneElement, useContext, useState } from 'react';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Button, 
  IconButton, 
  Box, 
  Menu, 
  MenuItem,
  useTheme,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Badge,
  ListItemButton,
  useMediaQuery,
  Avatar
} from '@mui/material';
import { 
  Brightness4 as DarkIcon, 
  Brightness7 as LightIcon,
  Translate as TranslateIcon,
  Menu as MenuIcon,
  Home as HomeIcon,
  Info as InfoIcon,
  ContactPhone as ContactIcon,
  Close as CloseIcon,
  ShoppingCart as CartIcon,
  Logout,
  ContactSupport,
  SupervisorAccount,
  ArrowDropDown
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ColorModeContext } from '../App';

import DashboardIcon from '@mui/icons-material/Dashboard';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ListAltIcon from '@mui/icons-material/ListAlt';
import AddBoxIcon from '@mui/icons-material/AddBox';
import StorefrontIcon from '@mui/icons-material/Storefront';
import PersonIcon from '@mui/icons-material/Person';
import PostAddIcon from '@mui/icons-material/PostAdd';
import SettingsIcon from '@mui/icons-material/Settings';
import { useSelector } from 'react-redux';

// Try to import the logo if it exists
let logoUrl;
try {
  // Update the case to match the actual file name
  logoUrl = require('../assets/Logo.png');
} catch (error) {
  // If logo doesn't exist, use a placeholder or text logo
  logoUrl = null;
}

const Header = () => {
  const theme = useTheme();
  const colorMode = useContext(ColorModeContext);
  const { t, i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const isRtl = i18n.language === 'ar';
  const location = useLocation();
    const navigate = useNavigate();  // ADD THIS

    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleLanguageMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLanguageMenuClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
    handleLanguageMenuClose();
    // Change the document direction based on language
    document.dir = language === 'ar' ? 'rtl' : 'ltr';
  };

    const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate('/login');
    setMobileOpen(false);
  };



  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };


  // const cartCount = 2;
// const ordersCount = 3;
  // Navigation items
const user = JSON.parse(localStorage.getItem('user'));
  const getUserInitials = () => {
    if (!user?.userName) return '';
    const names = user.userName.split(' ');
    return names
      .map(name => name[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  const [userMenuAnchorEl, setUserMenuAnchorEl] = useState(null);

const handleUserMenuOpen = (event) => {
  setUserMenuAnchorEl(event.currentTarget);
};

const handleUserMenuClose = () => {
  setUserMenuAnchorEl(null);
};

const {cartCounter} = useSelector((state)=>state.cartSlice)
const {ordersCounter} = useSelector((state)=>state.orderSlice)
console.log("cartCounter",cartCounter);
let navItems = [];

if (user?.type === 'admin') {
  navItems = [
    { 
      label: t('header.home'), 
      path: '/adminHome', 
      icon: <DashboardIcon color="primary" />
    },
    { 
      label: t('header.profile'), 
      path: '/AdminProfile', 
      icon: <AccountCircleIcon color="primary" />
    },
  ];

  if (user.superAdmin) {
    navItems.push({
      label: t('header.admins'),
      path: '/admins',
      icon: <SupervisorAccount color="primary" />
    });
  }
}

if (user?.type === 'client') {
  navItems = [
    { 
      label: t('header.home'), 
      path: '/home', 
      icon: <HomeIcon color="primary" />
    },
    { 
       label: !isMobile ? (
    <Badge badgeContent={ordersCounter?.totalOrderItems} color="error">
      {t('header.myOrders')}
    </Badge>
  ) : (
    t('header.myOrders')
  ),
      path: '/MyOrders', 
      icon: (
        <Badge badgeContent={ordersCounter?.totalOrderItems} color="error">
          <ListAltIcon color="primary" />
        </Badge>
      )
    },
    { 
      label: t('header.profile'), 
      path: '/profile', 
      icon: <AccountCircleIcon color="primary" />
    },
    { 
      label: t('header.contact'), 
      path: '/ContactUs', 
      icon: <ContactSupport color="primary" />
    },
    { 
      label:  t('header.cart'),
      path: '/cart', 
      icon: (
        <Badge badgeContent={cartCounter?.totalCartItems} color="error">
          <ShoppingCartIcon color="primary" />
        </Badge>
      ),
    },
    // يمكنك إضافة عناصر أخرى مثل حول/about أو تواصل/contact إذا أحببت:
    // { label: t('header.about'), path: '/about', icon: <InfoIcon color="primary" /> },
    // { label: t('header.contact'), path: '/contact', icon: <ContactMailIcon color="primary" /> },
  ];
}

if (user?.type === 'family') {
  navItems = [
    { 
      label: t('header.home'), 
      path: '/familyHome', 
      icon: <HomeIcon color="primary" />
    },
       { 
      label:(
        <Badge badgeContent={ordersCounter?.totalOrderItems} color="error">
          {t('header.orders')}
        </Badge>
      ), 
      path: '/FamilyOrders', 
      icon: (
        <Badge badgeContent={ordersCounter?.totalOrderItems} color="error">
          <ListAltIcon color="primary" />
        </Badge>
      )
    },
    { 
      label: t('header.addProduct'), 
      path: '/addProduct', 
      icon: <AddBoxIcon color="primary" />
    },
    { 
      label: t('header.profile'), 
      path: '/FamilyProfile', 
      icon: <AccountCircleIcon color="primary" />
    },
     { 
      label: t('header.contact'), 
      path: '/ContactUs', 
      icon: <ContactSupport color="primary" />
    },
    // مثال: عرض المنتجات أو إدارة المتجر:
    // {
    //   label: t('header.myProducts'),
    //   path: '/myProducts',
    //   icon: <StorefrontIcon color="primary" />
    // },
  ];
}



  const drawer = (
    <Box 
      sx={{ 
        width: 280, 
        height: '100%',
        bgcolor: 'background.paper',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'flex-end', 
        p: 2,
        bgcolor: 'primary.main',
        color: 'primary.contrastText'
      }}>
        <IconButton 
          onClick={handleDrawerToggle} 
          aria-label="close menu"
          color="inherit"
        >
          <CloseIcon />
        </IconButton>
      </Box>
      
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        p: 3,
        mb: 1
      }}>
        {logoUrl ? (
          <img 
            src={logoUrl}
            alt={t('header.logoAlt')}
            style={{ 
              height: '70px',
              objectFit: 'contain',
              maxWidth: '100%'
            }}
          />
        ) : (
          <Typography 
            variant="h5" 
            component="div" 
            sx={{ 
              fontWeight: 'bold',
              color: 'primary.main'
            }}
          >
            {t('header.organizationName')}
          </Typography>
        )}
      </Box>
             {/* User Profile Section in Drawer */}
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            p: 2,
            borderBottom: `1px solid ${theme.palette.divider}`
          }}>
            <Avatar 
              src={user?.image || ''} 
              sx={{ 
                width: 48, 
                height: 48,
                bgcolor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                fontSize: '1rem',
                ml: 1
              }}
            >
              {!user?.image && getUserInitials()}
            </Avatar>
            <Box>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ml:1}}>
                {user?.userName}
              </Typography>
              <Typography variant="body2" color="textSecondary" sx={{ml:1}}>
                {t(`user.${user?.type}`)}
              </Typography>
            </Box>
          </Box>
      <Divider />
      
     <List sx={{ width: 250, flexGrow: 1 /* أو أي عرض تفضله */ }}>
        {navItems.map((item) => (
          <ListItemButton
            key={item.path}
            component={Link}
            to={item.path}
            onClick={handleDrawerToggle}
            selected={location.pathname === item.path}
            sx={{
              '&.Mui-selected': {
                bgcolor: 'primary.light',
                '&:hover': {
                  bgcolor: 'primary.light',
                },
              },
              // إذا أردت نص يميني بشكل صريح:
              textAlign: isRtl ? 'right' : 'left',
            }}
          >
            {/* 
              إذا أردت تضمين الأيقونة:
              MUI يتعامل مع الـ direction ويقوم بعكس المسافات تلقائياً في RTL 
            */}
            {item.icon && (
              <ListItemIcon sx={{ minWidth: 40, color: location.pathname === item.path ? 'primary.main' : 'inherit' }}>
                {item.icon}
              </ListItemIcon>
            )}
            <ListItemText
              primary={item.label}
              primaryTypographyProps={{
                fontWeight: location.pathname === item.path ? 600 : 'normal',
              }}
            />
          </ListItemButton>
        ))}

        {user && (
          <ListItemButton
            onClick={handleLogout}
            sx={{
              color: 'error.main',
              '&:hover': {
                bgcolor: 'error.light',
              },
              textAlign: isRtl ? 'right' : 'left',
            }}
          >
            <ListItemIcon sx={{ minWidth: 40, color: 'error.main' }}>
              {/* استورد Logout من '@mui/icons-material/Logout' */}
              <Logout />
            </ListItemIcon>
            <ListItemText
              primary={t('header.logout')}
              primaryTypographyProps={{ fontWeight: 'bold' }}
            />
          </ListItemButton>
        )}
      </List>
      {/* <Divider /> */}
      
      <Box sx={{ p: 2, bgcolor: 'background.default' }}>
        {/* <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2" sx={{ mb: 1, opacity: 0.8 }}>
            {t('header.language')}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button 
              variant={i18n.language === 'en' ? 'contained' : 'outlined'} 
              size="small" 
              onClick={() => changeLanguage('en')}
              color="primary"
              fullWidth
            >
              English
            </Button>
            <Button 
              variant={i18n.language === 'ar' ? 'contained' : 'outlined'} 
              size="small" 
              onClick={() => changeLanguage('ar')}
              color="primary"
              fullWidth
            >
              العربية
            </Button>
          </Box>
        </Box> */}
        
        {/* <Box>
          <Typography variant="subtitle2" sx={{ mb: 1, opacity: 0.8 }}>
            {t('header.theme')}
          </Typography>
          <Button 
            variant="outlined" 
            size="small" 
            startIcon={theme.palette.mode === 'dark' ? <LightIcon sx={{ml:2}} /> : <DarkIcon sx={{ml:2}} />}
            onClick={colorMode.toggleColorMode}
            color="primary"
            fullWidth
          >
            {t(theme.palette.mode === 'dark' ? 'header.lightMode' : 'header.darkMode')}
          </Button>
        </Box> */}
      </Box>
    </Box>
  );

  return (
    <AppBar 
      position="sticky" 
      elevation={0}
      sx={{ 
        bgcolor: 'background.paper',
        color: 'text.primary',
        borderBottom: `1px solid ${theme.palette.divider}`,
        width: '100%',
        zIndex: theme.zIndex.drawer + 1
      }}
    >
      <Toolbar sx={{ 
        px: { xs: 2, sm: 3, md: 4 },
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        {/* Logo */}
        <Box 
          sx={{ 
            display: 'flex', 
            alignItems: 'center',
            mr: 2,
            flexShrink: 0
          }}
          component={Link} 
          to="/"
          style={{ textDecoration: 'none' }}
        >
          {logoUrl ? (
            <img 
              src={logoUrl}
              alt={t('header.logoAlt')}
              style={{ 
                height: '60px',
                objectFit: 'contain',
                maxWidth: '120px'
              }}
            />
          ) : (
            <Typography 
              variant="h6" 
              component="div"
              sx={{ 
                fontWeight: 700,
                color: 'primary.main'
              }}
            >
              {t('header.organizationShortName')}
            </Typography>
          )}
        </Box>
        
        {/* Desktop Navigation */}
        <Box sx={{ 
          display: { xs: 'none', md: 'flex' }, 
          flexGrow: 1, 
          justifyContent: 'center',
          gap: 1,
          mx: 4
        }}>
          {navItems.map((item) => (
        <Button
          key={item.path}
          component={Link}
          to={item.path}
          // startIcon={
          //   item.path === '/cart' ? (
          //     <Badge badgeContent={4} color="error">
          //       <CartIcon sx={{ mr: 1 }} />
          //     </Badge>
          //   ) : (
          //     item.icon && cloneElement(item.icon, { sx: { mr: 1 } })
          //   )
          // }
          color={location.pathname === item.path ? 'primary' : 'inherit'}
          variant={location.pathname === item.path ? 'text' : 'text'}
          sx={{
            fontWeight: 600,
            borderRadius: 2,
            px: 1,
            '&.MuiButton-contained': {
              boxShadow: theme.shadows[1],
            },
          }}
        >
          {item.label == t('header.cart')  ? item.icon : item.label }
        </Button>
      ))}
        </Box>

        {/* Right Side Controls */}
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center',
          gap: { xs: 0.5, sm: 1 }
        }}>
          {/* <IconButton
            color="primary"
            onClick={handleLanguageMenuOpen}
            aria-label={t('header.language')}
            size="medium"
          >
            <TranslateIcon />
          </IconButton> */}
          
          {/* <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleLanguageMenuClose}
            PaperProps={{
              sx: {
                mt: 1.5,
                minWidth: 120
              }
            }}
          >
            <MenuItem 
              onClick={() => changeLanguage('en')}
              selected={i18n.language === 'en'}
            >
              English
            </MenuItem>
            <MenuItem 
              onClick={() => changeLanguage('ar')}
              selected={i18n.language === 'ar'}
            >
              العربية
            </MenuItem>
          </Menu> */}

          {/* Dark/Light Mode Toggle */}
          {/* <IconButton 
            color="primary" 
            onClick={colorMode.toggleColorMode}
            aria-label={theme.palette.mode === 'dark' ? t('header.lightMode') : t('header.darkMode')}
            size="medium"
          >
            {theme.palette.mode === 'dark' ? <LightIcon /> : <DarkIcon />}
          </IconButton> */}

            {/* User Profile Section */}
{user && (
  <>
    <Box
      onClick={handleUserMenuOpen}
      sx={{
        display: { xs: 'none', md: 'flex' },
        alignItems: 'center',
        gap: 1,
        ml: 1,
        mr: 1,
        py: 1,
        px: 2,
        borderRadius: '12px',
        backgroundColor: theme.palette.action.hover,
        transition: 'background-color 0.3s ease',
        cursor: 'pointer',
        minWidth: 180,
        '&:hover': {
          backgroundColor: theme.palette.action.selected,
        },
      }}
    >
      <Avatar 
        src={user?.image || ''} 
        sx={{ 
          width: 36, 
          height: 36,
          bgcolor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          fontSize: '0.875rem'
        }}
      >
        {!user?.image && user?.userName?.charAt(0).toUpperCase()}
      </Avatar>
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        <Typography variant="subtitle2" fontWeight="bold">
          {user?.userName}
        </Typography>
        <Typography variant="caption" color="textSecondary">
          {t(`user.${user?.type}`)}
        </Typography>
      </Box>

      {/* سهم يدور حسب حالة القائمة */}
      <ArrowDropDown
        sx={{
          color: 'text.secondary',
          transition: 'transform 0.3s ease',
          transform: Boolean(userMenuAnchorEl) ? 'rotate(180deg)' : 'rotate(0deg)',
        }}
      />
    </Box>

    <Menu
      anchorEl={userMenuAnchorEl}
      open={Boolean(userMenuAnchorEl)}
      onClose={handleUserMenuClose}
      MenuListProps={{
        autoFocusItem: false,
      }}
      PaperProps={{
        sx: {
          mt: 1,
          minWidth: 180,
        },
      }}
    >
      <MenuItem
        onClick={() => {
          handleUserMenuClose();
          handleLogout();
        }}
        sx={{
          color: 'error.main',
          '& svg': {
            color: 'error.main',
          },
        }}
      >
        <Logout fontSize="small" sx={{ ml: 1 }} />
        {t('header.logout')}
      </MenuItem>
    </Menu>
  </>
)}


          {/* Mobile Menu Button */}
         {user && <IconButton
            color="primary"
            aria-label="menu"
            onClick={handleDrawerToggle}
            sx={{ 
              ml: { xs: 0.5, sm: 1 },
              display: { md: 'none' } 
            }}
          >
            <MenuIcon />
          </IconButton>}
        </Box>
      </Toolbar>

      {/* Mobile Drawer */}
     {user && <Drawer
        variant="temporary"
        anchor={isRtl ? 'right' : 'left'}
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': { 
            width: 280,
            boxSizing: 'border-box'
          },
        }}
      >
  
          
        {drawer}
      </Drawer>}
    </AppBar>
  );
};

export default Header;